
import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { SeismicContractorDto, UserStaffDetailDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { Guid } from 'guid-typescript';
import { GatewayService } from 'libs/gateway/src/lib/services/gateway.service';
import { AuthFacade } from 'libs/auth/src/lib/facades/auth.facade';
import { stringToKeyValue } from '@angular/flex-layout/extended/typings/style/style-transforms';
@Component({
  selector: 'cradua-contractor-container',
  templateUrl: './contractor-container.component.html',
  styleUrls: ['./contractor-container.component.scss']
})
export class ContractorContainerComponent implements OnInit {
  isSearching = false;
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  seismiccontractors$: Observable<SeismicContractorDto[]>;
  loading: boolean;
  isLoadingSeismicContractor$: Observable<boolean>;
  href: string = "";
  constructor(
    private gatewayFacade: GatewayFacade,
    private notificationService: NotificationService,
    private gatewayService: GatewayService,
    private authFade: AuthFacade
  ) {}

  ngOnInit() {
 
    this.isLoadingSeismicContractor$ = this.gatewayFacade.isLoadingGateway("SeismicContractor");

    this.seismiccontractors$ = this.gatewayFacade.loadGateway("SeismicContractor");
  }


/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteSeismicContractor(deletedValue: any) {
    this.isSearching = false;
    this.gatewayFacade.remove("SeismicContractor", deletedValue);
    // this.store.dispatch(SeismicContractorStoreActions.removeSeismicContractor({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }

  searchContractors(contractorName) {
    this.isSearching = true;
    this.gatewayFacade.genericFilterGateway('SeismicContractor', 'ContractorName', contractorName);
  }

// this method control both the create and update

  onSubmitSeismicContractor(formValue: any) {
    this.isSearching = false;
    // console.log("form value: ", formValue);
  
    
    const pullData = formValue.SeismicContractors;
    //const newPullData = formValue.SeismicContractores;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllSeismicContractor = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      const staff = {
        StaffId: '',
        LastName:  pullData[i].ContractorName,
        FirstName:  pullData[i].ContractorName,
        MiddleName: pullData[i].ContractorName,
        PhoneNo:  pullData[i].PhoneNo,
        EmailAddress: pullData[i].Email,
        Address: pullData[i].Address,
        StaffName: pullData[i].ContractorName,
      }

      // console.log('users', staff, pullData[i]);
      addAllSeismicContractor.push(pullData[i]);
      this.RegisterContractor(staff);
    }
  }
  // return;
// check if the addAllSeismicContractor array is not empty, then dispatch the data to the store
   if(addAllSeismicContractor.length !== 0) {
    this.gatewayFacade.add('SeismicContractor', addAllSeismicContractor);
    // this.store.dispatch(SeismicContractorStoreActions.addSeismicContractor({newSeismicContractor: addAllSeismicContractor}));

   }

// dispatch update data to the store
  this.gatewayFacade.update('SeismicContractor', allUpdates, ['id']);
    // this.store.dispatch(SeismicContractorStoreActions.updateSeismicContractor({updateSeismicContractor: allUpdates}));
    this.notificationService.success('Saved Successfully');

  }


  RegisterContractor(pullData) {
  // return;
    this.gatewayFacade.add("UserStaffDetail", pullData);
    

    const date = new Date();
    date.setDate(date.getDate() + 2);
  
  
    // this.userUpdate.resetPasswordExpires = date;
    // this.userUpdate.resetPasswordToken = this.generateRandomString(35);
  
    let user = {
      UserName: pullData.EmailAddress,
      Email: pullData.EmailAddress,
      PhoneNo: pullData.PhoneNo,
      FirstName: pullData.FirstName,
      LastName: pullData.LastName,
      StaffName: pullData.StaffName,
      password: 'welcome',
      UserType: 'Contractor',
      SubscriberId: pullData.SubscriberId,
      userRole: 'Contractor',
      Id:  Guid.create().toString(),
      resetPasswordExpires: date,
      resetPasswordToken: this.generateRandomString(35)
    };
  
    let newAdd = [];
    newAdd.push(user)
    this.authFade.addNewUser(newAdd);

    let mailData = { fromEmail: '', toEmail: user.Email, subject: 'Manage Account', task:'', responsibility: '',
    pipelinename: '', pipelinerequestdesc: '', period: '', message: '', salutation: '', footer: '', url: ''};
  
    let salute = "Dear " + user.StaffName + ' ,';
  
    let conformButtonMsg = "";
  
  
    mailData.salutation = salute;
   
    mailData.message = "Click on the link below to change your password";
    
    mailData.footer = '';
   
  
   let linkURL = this.href + '#/auth/manage/' + user.Id + '/' + user.resetPasswordToken;
   mailData.url = linkURL;
   
    this.gatewayService.sendManageAccountMail(mailData).subscribe((data) => {
  
   });
   }
  
  
   generateRandomString (length, randomString="") {
    randomString += Math.random().toString(20).substr(2, length);
    if (randomString.length > length) return randomString.slice(0, length);
    return this.generateRandomString(length, randomString);
  };

}



